import { useMediaQuery } from 'react-responsive';

const DefaultSm = ({ children }) => {
  const isNotMobileSm = useMediaQuery({ minWidth: 576 });
  return isNotMobileSm ? children : null;
};

export default DefaultSm;
